// React i hooks
import { NavLink } from "react-router-dom";
import { memo } from "react";

// Helpers
import { classNames, useTranslate } from "helpers";

// Moduli specifični za projekt
import { Routes as SettingRoutes } from "ui/modules/settings/navigation";

// Tipovi i konstante
import { TabMenuProps } from "./types";

const TabMenu: React.FC<TabMenuProps> = () => {

  const { t } = useTranslate();

  return (
    <>
      <div className="flex border-b border-slate-200 bg-white">
        <NavLink
          to={SettingRoutes.SettingDetailPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.settings.tab.details")}
        </NavLink>
         <NavLink
          to={SettingRoutes.OfficesSearchPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          Poslovnice
        </NavLink>
          <NavLink
          to={SettingRoutes.FleetSettingDetailPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.settings.tab.fleet")}
        </NavLink>
      
       <NavLink
          to={SettingRoutes.DocumentDetailPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.settings.tab.document")}
        </NavLink>
        <NavLink
          to={SettingRoutes.ListingDefaultsDetailPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.settings.tab.listingdefaults")}
        </NavLink>
      </div>
    </>
  );
};

export default memo(TabMenu);
